import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleProductModal } from 'redux/modules/trolley/actions/toggle-product-modal';
import { getSwapUnavailableProductModal } from 'redux/modules/trolley/selectors/get-swap-unavailable-product-modal';
import { notifyModalClosed } from 'redux/modules/common-modal/actions';

import { viewAlternativesModal } from 'constants/modals';

import SwapUnavailableProductModal from 'components/SwapUnavailableProductModal';
import Button from '@johnlewispartnership/wtr-ingredients/ingredients/Button';
import { ListAnalytics } from 'analytics/types';

const ViewAlternativesProductModal = ({ listDefinitions }: { listDefinitions?: ListAnalytics }) => {
  const dispatch: WtrDispatch = useDispatch();

  const { modalId } = useSelector(getSwapUnavailableProductModal);

  const onCloseModal = useCallback(() => {
    dispatch(toggleProductModal());
    dispatch(
      notifyModalClosed({
        ...viewAlternativesModal,
        title: viewAlternativesModal.titleText,
      }),
    );
  }, [dispatch]);

  const ViewAlternativesModalButton = useCallback(
    () => <Button data-testid="done-btn" onClick={onCloseModal} label="Done" theme="finalising" />,
    [onCloseModal],
  );

  return (
    <>
      {modalId === viewAlternativesModal.id ? (
        <SwapUnavailableProductModal
          BodyButton={ViewAlternativesModalButton}
          onCloseModal={onCloseModal}
          isProductRemovable={false}
          titleText="VIEW ALTERNATIVES"
          subTitleText="Choose an alternative to add to your trolley"
          productPodAddText="Add"
          listDefinitions={listDefinitions}
        />
      ) : null}
    </>
  );
};

export default ViewAlternativesProductModal;
